
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'product-card__badge product-card__badge--' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n        ', badge, '\n      ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'product-card-wrap' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('a', {
                    'href': this.url,
                    'className': 'product-card reveal in-view'
                }, _createElement.apply(this, [
                    'div',
                    { 'className': 'product-card__badges' },
                    this.out_of_stock ? _createElement('span', {
                        'className': 'product-card__badge product-card__badge--soldout',
                        'key': '206'
                    }, '\n        ', _translate(`product_out_of_stock`), '\n      ') : null,
                    this.on_sale && !this.out_of_stock ? _createElement('span', {
                        'className': 'product-card__badge product-card__badge--sale',
                        'key': '362'
                    }, '\n        Sale\n      ') : null,
                    !this.out_of_stock && this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ]), _createElement('div', { 'className': 'product-card__img-wrap' }, this.image ? _createElement('img', {
                    'src': this.resizeImage(this.image),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError,
                    'key': '777'
                }) : null, !this.image ? _createElement('div', {
                    'className': 'product-card__img-placeholder',
                    'key': '912'
                }) : null), _createElement('div', { 'className': 'product-card__info' }, this.vendor ? _createElement('p', {
                    'className': 'product-card__fitment mono-label gold-text',
                    'key': '1032'
                }, '\n        ', this.vendor.toUpperCase(), '\n      ') : null, _createElement('h3', mergeProps({ 'className': 'product-card__name' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), this.price ? _createElement('p', {
                    'className': 'product-card__price',
                    'key': '1324'
                }, this.on_sale ? [
                    this.price_varies ? _createElement('span', { 'key': '13831' }, _translate(`price_from`), ' ') : null,
                    _createElement('span', {
                        'className': 'product-card__price-sale',
                        'key': '13833'
                    }, this.formatPrice(this.min_price || this.price)),
                    _createElement('s', {
                        'className': 'product-card__price-compare',
                        'key': '13835'
                    }, this.formatPrice(this.compare_at_price))
                ] : null, !this.on_sale ? [
                    this.price_varies ? _createElement('span', { 'key': '17251' }, _translate(`price_from`), ' ') : null,
                    '\n          ',
                    this.formatPrice(this.min_price || this.price),
                    '\n        '
                ] : null) : null)), !this.is_promotional_item && !this.out_of_stock && this.variant_ids.length === 1 && !this.has_options ? _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'encType': 'multipart/form-data',
                    'data-quick-add-form': true,
                    'key': '1951'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids[0]
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'quantity',
                    'value': this.set_qty || 1
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '2320'
                }) : null, _createElement('button', {
                    'type': 'submit',
                    'className': 'product-card__quick-add',
                    'aria-label': 'Quick add ' + this.removeHTML(this.title)
                }, '\n      + Quick add\n    ')) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []